{
  "id": "tensor-network-seam-contraction",
  "kind": "tensor_network",
  "title": "Seam contraction — native tensor network",
  "description": "A DATA.ORIGIN tensor and a DATA.REACH tensor share indices only through the seam tensor. The free audit leg keeps the crossing witness explicit while the contracted bonds show bounded cross-seam information flow.",
  "tensor_network": {
    "interactive": {
      "backend": "d3_v7",
      "static_fallback": "tensor-network-seam-contraction-static",
      "csp_constraint": "self_only"
    },
    "title": "Seam contraction",
    "tensors": [
      {
        "id": "origin",
        "label": "O",
        "x": 0,
        "y": 0,
        "color": "data_origin",
        "shape": "box"
      },
      {
        "id": "seam",
        "label": "\\sigma",
        "x": 1,
        "y": 0,
        "color": "seam"
      },
      {
        "id": "reach",
        "label": "R",
        "x": 2,
        "y": 0,
        "color": "data_reach",
        "shape": "box"
      },
      {
        "id": "audit",
        "label": "\\delta",
        "x": 1,
        "y": 1,
        "color": "precommit",
        "shape": "dot"
      }
    ],
    "bonds": [
      {
        "from": "origin",
        "to": "seam",
        "label": "i",
        "dim": "d",
        "color": "data_origin"
      },
      {
        "from": "seam",
        "to": "reach",
        "label": "j",
        "dim": "d",
        "color": "data_reach"
      },
      {
        "from": "seam",
        "to": "audit",
        "label": "w",
        "color": "seam"
      }
    ],
    "legs": [
      {
        "tensor": "origin",
        "label": "source",
        "dir": "left",
        "color": "data_origin"
      },
      {
        "tensor": "reach",
        "label": "target",
        "dir": "right",
        "color": "data_reach"
      },
      {
        "tensor": "audit",
        "label": "witness",
        "dir": "down",
        "color": "precommit"
      }
    ]
  },
  "csk_metadata": {
    "theorems": [
      "DATA.ORIGIN",
      "DATA.REACH",
      "SEPARATE"
    ],
    "color_role": "seam"
  }
}
